import React from "react";
import styles from "./Status.module.css";
import { Col } from "react-bootstrap";

const Status = ({ image, showTime, num, day, finalStatus }) => {
  return (
    <Col md={3} data-aos="fade-right" data-aos-duration={`${showTime}`}>
      <div className={`${styles.box} ${finalStatus ? styles.finalStatus : ""}`}>
        <img src={image} alt="" className={styles.boxImage} />
        <div className={styles.boxContent}>
          <h1>{num}</h1>
          <h2>{day}</h2>
        </div>
      </div>
    </Col>
  );
};

export default Status;
